<div class="gl-page">
  <!-- Back link -->
  <yds-button-back text="Ga terug 'Loonjournaal voor rapportage'" (back)="goBack()" />

  <!-- Title -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Loonjournaal verwerking</h1>
  </div>

  <yds-card>
    <form class="gl-form" [formGroup]="form">
      <p class="gl-form__required-hint">
        Velden gemarkeerd met een sterretje
        (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
      </p>

      <div class="gl-field">
        <label class="gl-field__label">Opdrachtgever</label>
        <div class="gl-field__control">
          <p class="gl-field__readonly-text">{{ opdrachtgeverName() || 'n.v.t.' }}</p>
        </div>
      </div>

      <div class="gl-field">
        <label class="gl-field__label">
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Boekingsgroep
        </label>
        <div class="gl-field__control">
          <yds-dropdown
            [items]="bookingGroupOptions()"
            formControlName="bookingGroupId"
            [allowClear]="false"
            [required]="true"
            [hasError]="isInvalid(form.get('bookingGroupId'))"
            [errorMsg]="'Boekingsgroep is verplicht.'"
          />
        </div>
      </div>

      <div class="gl-form__switches">
        <div class="gl-field gl-field--inline">
          <label class="gl-field__label">Toepassen loonverdeling</label>
          <div class="gl-field__control">
            <yds-switch formControlName="applyWagePartitioning" />
          </div>
        </div>

        <div class="gl-field gl-field--inline">
          <label class="gl-field__label">Toepassen herverdeling</label>
          <div class="gl-field__control">
            <yds-switch formControlName="applyRedistribution" />
          </div>
        </div>
      </div>
    </form>

    <div class="cbr-footer">
      <yds-button
        variant="primary"
        class="cbr-submit-btn"
        [disabled]="isSaving() || form.invalid"
        (click)="onStartVerwerkingClick()"
      >
        @if (isSaving()) {
          <yds-spinner size="sm" label="Verwerking starten..." class="cbr-submit-btn__spinner" />
        }
        <span>Start verwerking</span>
      </yds-button>
    </div>
  </yds-card>
</div>
